import AudioEditorToolbar from "./AudioEditorToolbar";

export default AudioEditorToolbar;
